//import {START_LOADING,END_LOADING,SHOW_ATMODAL,HIDE_ATMODAL} from '../constants/ActionTypes'
import * as types from '../constants/ActionTypes'

const initialState = {
	loading:false,
	scrollHeight: 0
};

export default function util(state = initialState, action) {
  	switch (action.type) {
	    case types.SET_LOADING:
	        return Object.assign({}, state,{loading:action.data});
	    case types.SET_SCROLL_HEIGHT:
	        return Object.assign({}, state,{scrollHeight:document.documentElement.clientHeight - action.data * parseFloat(document.documentElement.style.fontSize)});
    // case SHOW_ATMODAL:
    //   return Object.assign({}, state,{atModalVisible:true});
    // case HIDE_ATMODAL:
    //   return Object.assign({}, state,{atModalVisible:false});
	    default:
	      return state
  }
}


// WEBPACK FOOTER //
// ./project/reducers/util.js